import * as React from 'react';
import { useContext } from 'react';

export type PageNavigationContextType = {
  showFixedPageNav: boolean;
  showPageCtaInNav: boolean;
  showFixedMobileCta: boolean;
  sectionInView?: string;
  sectionRefs?: Record<string, HTMLDivElement>;
  navigationLinkKeys: string[];
  fixedPageNavHeight?: number;
  updatePageCtaPosition?: (top: number) => void;
  updateInPageNavPosition?: (top: number, isScrollingDown?: boolean) => void;
  updateFixedPageNavHeight?: (height: number) => void;
  addSectionElementRef?: (anchorId: string, sectionRef: HTMLDivElement) => void;
  updateSectionInView?: () => void;
  navigationLinks?: Array<{ name: string; label: string }>;
};

const PageNavigationContext = React.createContext<PageNavigationContextType>({
  showFixedPageNav: false,
  showPageCtaInNav: false,
  showFixedMobileCta: false,
  navigationLinkKeys: [],
  sectionRefs: {},
});

export const usePageNavigation = () => {
  const pageNavigation = useContext(PageNavigationContext);

  return pageNavigation;
};

export default PageNavigationContext;
